import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useMemo } from 'react';
import * as THREE from 'three';
import { shortestCircularDelta } from '../../_pure/circularTravel.js';
export function RingPulse({ pulse }) {
    const resources = useMemo(() => {
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(65 * 3), 3).setUsage(THREE.DynamicDrawUsage));
        const material = new THREE.LineBasicMaterial({ transparent: true, depthTest: false });
        return { geometry, material };
    }, []);
    useLayoutEffect(() => {
        if (![pulse.radius, pulse.height, pulse.fromAngle, pulse.toAngle, pulse.progress01].every(Number.isFinite)
            || pulse.radius <= 0)
            throw new Error('Invalid circular pulse geometry.');
        const delta = shortestCircularDelta(pulse.fromAngle, pulse.toAngle);
        const progress = Math.max(0, Math.min(1, pulse.progress01));
        const halfWidth = Math.min(Math.abs(delta) / 2, 1.5 / pulse.radius);
        const center = pulse.fromAngle + delta * progress;
        const position = resources.geometry.getAttribute('position');
        for (let index = 0; index <= 64; index++) {
            const angle = center + (index / 64 * 2 - 1) * halfWidth;
            position.setXYZ(index, Math.cos(angle) * pulse.radius, pulse.height, Math.sin(angle) * pulse.radius);
        }
        position.needsUpdate = true;
        resources.material.color.set(pulse.color);
        resources.material.opacity = Math.min(1, progress * 10, (1 - progress) * 10);
    }, [pulse, resources]);
    useEffect(() => () => { resources.geometry.dispose(); resources.material.dispose(); }, [resources]);
    return _jsx("primitive", { object: useMemo(() => new THREE.Line(resources.geometry, resources.material), [resources]), frustumCulled: false, dispose: null });
}
